import { css } from 'styled-components';
import { styleAttribute } from '@fil-react-mixins/styled';
export default css `
  ${({ display }) => display && styleAttribute('display', display)}
`;
